namespace GeniuzPOS.AdvPromo {
    export namespace PsAdvPromoItem3ExemptService {
        export const baseUrl = 'AdvPromo/PsAdvPromoItem3Exempt';

        export declare function Create(request: Serenity.SaveRequest<PsAdvPromoItem3ExemptRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PsAdvPromoItem3ExemptRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PsAdvPromoItem3ExemptRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PsAdvPromoItem3ExemptRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "AdvPromo/PsAdvPromoItem3Exempt/Create",
            Update = "AdvPromo/PsAdvPromoItem3Exempt/Update",
            Delete = "AdvPromo/PsAdvPromoItem3Exempt/Delete",
            Retrieve = "AdvPromo/PsAdvPromoItem3Exempt/Retrieve",
            List = "AdvPromo/PsAdvPromoItem3Exempt/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PsAdvPromoItem3ExemptService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
